import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f5d778c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header" }, "Returnering av order", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Vill du returnera en eller flera av dina biljetter? Ange ditt bokningsnummer nedan så hämtar vi din bokning. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Det är möjligt att returnera delar av en bokning förutsatt att den kvarvarande bokningen uppfyller kraven på en godkänd bokning. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Det går tyvärr inte att returnera en bokning som redan aktiverat. ")
], -1))
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "ticket-wrapper"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header" }, "Biljetter returnerade", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Hämtar bokning", -1))
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Returnerar biljetter", -1))

import ContentWrapper from "../generics/ContentWrapper.vue";
import CustomInputField from "../generics/CustomInputField.vue";
import SectionHeader from "../generics/SectionHeader.vue";
import CustomButton from "../generics/CustomButton.vue";

import postEurailAPI from "@/functions/postEurailAPI";
import { reactive } from "vue";
import { order, useBookingStore } from "@/store/bookingStore";
import ticket from "@/types/ticket";
import CustomTable from "../generics/CustomTable.vue";
import sendReturnMail from "@/functions/sendReturnMail";
import CustomModal from "../generics/CustomModal.vue";
import CustomLoader from "@/components/generics/CustomLoader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReturnView',
  setup(__props) {

const state = reactive({
  orderNumber: "",
  fetchingOrder: false,
  returningTicket: false,
  ticketsReturned: false,
  order: {} as order,
  shoppingCart: [] as ticket[],
  eurailBooking: {} as any,
  error: "",
  refundError: "",
  ticketIdsToReturn: [] as string[],
});

const bookingStore = useBookingStore();

const backend_adress = process.env.VUE_APP_BACKEND_ADRESS;

function handleOrderNumber(event: any) {
  state.orderNumber = event;
}

function handleGetOrderClick() {
  console.log("Ping!")
  state.fetchingOrder = true;
  state.order = {} as order;
  state.eurailBooking = {} as any;
  state.shoppingCart = [] as ticket[];
  state.error = "";
  state.refundError = "";
  state.ticketIdsToReturn = [] as string[];
  getRefundableTickets(state.orderNumber);
}

function handleAddRemoveTicketFromReturnList(ticketId: string) {
  if (state.ticketIdsToReturn.includes(ticketId)) {
    const index_of = state.ticketIdsToReturn.indexOf(ticketId);
    if (index_of > -1) {
      state.ticketIdsToReturn.splice(index_of, 1);
    }
  } else {
    state.ticketIdsToReturn.push(ticketId);
  }
}

function handleReturnTickets() {
  console.log("Returning tickets...");
  returnTickets(state.ticketIdsToReturn);
}

function generate_table_view() {
  if (!state.shoppingCart) {
    return [];
  }
  return [
    ...state.shoppingCart.map((ticket: ticket) => {
      return [
        {
          Pass: ticket.title,
          Komfort: `${ticket.comfort}, ${ticket.age}`,
          Resenär: `${ticket.firstName} ${ticket.lastName}`,
          Aktiveringskod: ticket.mobileActivationCode,
          Pris: ticket.price,
        },
      ];
    }),
  ];
}

function orderFound() {
  return Object.keys(state.order).length === 0;
}

function getTicketsFromEurailID(ids: string[]) {
  let ticket_list = [] as ticket[];
  ids.forEach((uniqueID: string) => {
    state.shoppingCart.forEach((ticket) => {
      if (ticket.eurailTicketId == uniqueID) {
        ticket_list.push(ticket);
      }
    });
  });
  return ticket_list;
}

async function getRefundableTickets(id: string) {
  var message = {
    status: 400,
    statusMessage: "Unspecified error",
    body: "",
    concatenatedError: [],
    error: "",
  };

  // Start by calling our dB and receive the order connected to the entered id
  // - Create an instance of that order
  /*     var testOrder = new order_class();
    	console.log("Setting testOrder");
    	testOrder.fromJSON(JSON.parse(JSON.stringify(new_order)));
   		console.log("Set testOrder to:", testOrder); */
  let tempOrder = await getOrder(id);
  console.log(tempOrder)
  if (!tempOrder) {
    state.error =
      "Ordern gick inte att hitta. Säkerställ att ditt ordernummer är korrekt.";

    state.fetchingOrder = false;
    return;
  }
  tempOrder = await updateOrderVersion(tempOrder, message);
  // - Achieve its eurail order id and pass it into the getTicketStatus(id) function.

  await getTicketStatus(tempOrder.eurailOrderId, message).then(
    (result: any) => {
      console.log("result:", result);
      if (result.error) {
        var errorMessage;
        switch (result.concatenatedError[result.concatenatedError.length - 1]) {
          case "Not Found":
            errorMessage =
              "Ordern gick inte att hitta. Säkerställ att ditt ordernummer är korrekt.";
            break;
        }
        state.error = String(errorMessage);
        return;
      }
      if ("body" in result) {
        var index = 0;
        tempOrder.order.map((ticket: ticket) => {
          if (ticket.type === "ticket") {
            for (let i = 0; i < result.body.lineItems.length; i++) {
              console.log(result.body.lineItems);
              if (result.body.lineItems[i].id == ticket.eurailTicketId) {
                /* ticket.set_refundable(true); */
                ticket.refundable = true;
              }
            }

            index += 1;
          }
        });

        console.log("TempOrder");
        console.log(tempOrder);

        state.order = tempOrder;

        state.order = {
          firstname: tempOrder.firstname,
          surname: tempOrder.surname,
          adress: tempOrder.adress,
          city: tempOrder.city,
          postalNumber: tempOrder.postalNumber,
          phoneNumber: tempOrder.phoneNumber,
          swishPhoneNumber: tempOrder.swishPhoneNumber,
          email: tempOrder.email,
          swishFirstname: tempOrder.swishFirstname,
          swishSurname: tempOrder.swishSurname,
          acceptTermsAndConditions: tempOrder.acceptTermsAndConditions,
          originalPaymentReference: tempOrder.originalPaymentReference,
          CurrentSwishIdentifier: tempOrder.CurrentSwishIdentifier,
          bookStatus: tempOrder.bookStatus,
          shoppingCartId: tempOrder.shoppingCartId,
          eurailOrderNumber: tempOrder.eurailOrderNumber,
          eurailOrderId: tempOrder.eurailOrderId,
          orderStatus: tempOrder.orderStatus,
          tagluffaOrderNumber: tempOrder.tagluffaOrderNumber,
          eurailBooking: tempOrder.eurailBooking,
        };

        state.shoppingCart = tempOrder.order;
      }
    }
  );
  console.log("setting order to:", tempOrder);
  state.fetchingOrder = false;
}

async function getOrder(id: string) {

  const url = backend_adress + "/getOrderFromDB";
  let res = fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: id,
    }),
  })
    .then((resp) => resp.json())
    .then((data) => {
      if (1 > data.ans.length) {
        return;
      }
      var order = JSON.parse(data.ans[0].order);
      return order;
    });
  return res;
}

async function updateOrderVersion(tempOrder: any, message: any) {
  // Get order from Eurail API
  await getEurailOrder(tempOrder.eurailOrderId, message).then((result: any) => {
    if (result.error) {
      var errorMessage;
      switch (result.concatenatedError[result.concatenatedError.length - 1]) {
        case "Not Found":
          errorMessage =
            "Ordern gick inte att hitta. Säkerställ att ditt ordernummer är korrekt.";
          break;
      }
      state.error = String(errorMessage);
      return;
    }
    if ("body" in result) {
      // Version is refetched from eurail in order for version to match when making a return
      tempOrder.eurailBooking = result.body;
    }
  });
  // Update database with Eurail order info
  return tempOrder;
}

async function getTicketStatus(id: any, message: any) {
  message.body = id;
  var result = await postEurailAPI(message, "refundable", backend_adress);

  return result;
}

async function getEurailOrder(id: any, message: any) {
  message.body = id;
  var result = await postEurailAPI(message, "get_order", backend_adress);

  return result;
}

async function returnTickets(tickets: string[]) {
  // Return the tickets chosen by the customer to be returned. NOT all of the returnable.
  // Firstly, check whether the new order would be valid.
  if (bookingStore.is_order_invalid(state.order, state.shoppingCart)) {
    state.refundError =
      bookingStore.is_order_invalid(state.order, state.shoppingCart) +
      ". Åtgärda det och fortsätt sedan till returnering.";
    return;
  }

  // Proceed with refund.
  state.returningTicket = true;
  var message = {
    status: 400,
    statusMessage: "Unspecified error",
    body: "",
    concatenatedError: [],
    error: "",
  };

  //await tickets.map((ticket) => {
  await returnATicket(state.order.eurailOrderId, tickets, message).then(
    //ticket.get_eurail_ticket_id, message).then(
    (result: any) => {
      if (result.error) {
        var errorMessage;
        switch (result.concatenatedError[result.concatenatedError.length - 1]) {
          case "Not Found":
            errorMessage =
              "Ordern gick inte att hitta. Säkerställ att ditt ordernummer är korrekt.";
            break;
          case "Preparing swish payment did not succeed":
            if (result.concatenatedError[0] == "Payer not Enrolled") {
              errorMessage = "Felaktigt swishnummer.";
            }
            break;
          case "Swish payment failed.":
            errorMessage =
              "Swishbetalning genomfördes inte. Var god försök igen. Om det inte fungerar då, var vänlig kontakta kundservice.";
            break;
          case "Create order did not execute properly":
            //history.push("/order-error");
            break;
          default:
            console.log("The error:", result.error);
            errorMessage = result.error.error;
            break;
        }
        state.refundError = errorMessage;
        console.log(errorMessage);
        state.returningTicket = false;
      } else {
        sendReturnMail(
          state.order,
          getTicketsFromEurailID(tickets),
          getPriceOfTickets(tickets) - getFee(tickets),
          backend_adress
        ).then((response) => {
          if (response == "success") {
            console.log("Confirmation mail successfully sent.");
          } else {
            console.log("Failed to send confirmation mail.");
          }
        });
        state.returningTicket = false;
        state.ticketsReturned = true;
        // Send to confirmation page
      }
    }
  );
  return;
}

function getPriceOfTickets(tickets: string[]) {
  var total = 0;
  var ticket_list = getTicketsFromEurailID(tickets);
  ticket_list.forEach((element) => {
    total += Number(element.price);
  });
  return total;
}

function getFee(tickets: string[]) {
  var price = getPriceOfTickets(tickets);
  var free_return = freeReturn();
  var fee = free_return ? 0 : Math.ceil(price * 0.05);
  return fee;
}

function freeReturn() {
  //Placeholder to determine if an order is being returned within 14 days and thus is covered by ångerrätten.
  //Then return True
  var order_time = new Date(state.order.eurailBooking.createdAt);
  var time_now = new Date();

  // To calculate the time difference of two dates
  var Difference_In_Time = time_now.getTime() - order_time.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24));

  // You have the right to return if it has not been more than 14 days since the order was created
  var right_to_return = Difference_In_Days <= 14 ? true : false;

  console.log("The right to return is: ", right_to_return);

  return right_to_return;
}

async function returnATicket(
  orderId: string,
  ticketIds: string[],
  message: any
) {
  // This is returning an entire order at this stage

  let lineItems = [] as any[];

  ticketIds.forEach((element) => {
    lineItems.push({ id: element, quantity: 1 });
  });

  console.log("version" + state.order.eurailBooking.version);

  message.body = {
    message: {
      refundPaymentType: "auto",
      lineItems: lineItems,
      refundReason: {
        reason: "unknown",
        replaceOption: false,
        explanation: "Unknown",
      },
      refundState: "line-item-mobile-refund-requested",
    },
    order: orderId,
    version: state.order.eurailBooking.version,
  };
  var result = await postEurailAPI(message, "refund", backend_adress)
    .then((result) => {
      console.log(result);
      /*if ("status" in result && "body" in result) {
					if (result.status < 400) {
						order.set_eurail_booking(result.body);
						const url = backend_adress + "/update_order";
						fetch(url, {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify({
								order: order,
							}),
						});
					}
				}*/
      return result as any;
    })
    .catch(function (error) {
      console.log("Request failure: ", error);
    });
  console.log(result);

  // Update order in dB with new Eurail order dump existing in result variable
  if ("status" in result && "body" in result) {
    if (result.status < 400) {
      console.log("now");
      state.order.eurailBooking = result.body;
      const url = backend_adress + "/update_order";
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          order: state.order,
          id: state.order.eurailOrderId,
        }),
      }).catch(function (error) {
        console.log("Request failure: ", error);
      });
    }
  }

  return result;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        (!state.ticketsReturned)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(SectionHeader, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (orderFound())
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(CustomInputField, {
                        id: "return",
                        label: "Ordernummer",
                        onOnInput: _cache[0] || (_cache[0] = ($event: any) => (handleOrderNumber($event)))
                      }),
                      _createVNode(CustomButton, {
                        class: "button",
                        disabled: !state.orderNumber,
                        onOnClick: handleGetOrderClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Hämta min bokning ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!orderFound())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.shoppingCart, (returnCandidateTicket, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `ticket-${index}`
                      }, [
                        _createElementVNode("h2", _hoisted_6, "Biljett " + _toDisplayString(index + 1), 1),
                        _hoisted_7,
                        _createVNode(CustomTable, {
                          class: _normalizeClass(state.ticketIdsToReturn.includes(returnCandidateTicket.eurailTicketId as string) ? 'highlight-table': ''),
                          tableItems: [
              {
                Pass: returnCandidateTicket.title,
                Komfort: `${returnCandidateTicket.comfort}, ${returnCandidateTicket.age}`,
                Resenär: `${returnCandidateTicket.firstName} ${returnCandidateTicket.lastName}`,
                Aktiveringskod: returnCandidateTicket.mobileActivationCode,
                Pris: returnCandidateTicket.price,
              },
            ]
                        }, null, 8, ["class", "tableItems"]),
                        _createVNode(CustomButton, {
                          class: "select-button",
                          variant: "outlined",
                          onOnClick: ($event: any) => (
              handleAddRemoveTicketFromReturnList(
                returnCandidateTicket.eurailTicketId as string
              )
            )
                        }, {
                          default: _withCtx(() => [
                            (
                state.ticketIdsToReturn.includes(
                  String(returnCandidateTicket.eurailTicketId)
                )
              )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Exkludera biljett från retur "))
                              : _createCommentVNode("", true),
                            (
                !state.ticketIdsToReturn.includes(
                  String(returnCandidateTicket.eurailTicketId)
                )
              )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Välj biljett för retur "))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["onOnClick"])
                      ], 64))
                    }), 128)),
                    _createVNode(CustomButton, {
                      class: "select-button",
                      onOnClick: _cache[1] || (_cache[1] = ($event: any) => (handleReturnTickets())),
                      disabled: state.ticketIdsToReturn.length <= 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Returnera " + _toDisplayString(state.ticketIdsToReturn.length) + " biljetter ", 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (state.ticketsReturned)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(CustomModal, {
      show: state.fetchingOrder,
      "full-height": true,
      "un-removeable": true
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(CustomLoader),
          _hoisted_14
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(CustomModal, {
      show: state.returningTicket,
      "full-height": true,
      "un-removeable": true
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(CustomLoader),
          _hoisted_16
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})